import weekData from 'cldr-core/supplemental/weekData.json';
import { splitLocale } from '../localeUtils';
const firstDayMap = weekData.supplemental.weekData.firstDay;
const defaultFirstDay = 'sun';

/**
 * Returns first day of week based on country/region of the locale.
 * @param locale
 * @returns Day of week that is considered as the first day for the locale.
 */
export const getFirstDayOfWeek = locale => {
  // The types from the json file aren't that great so do a little typecasting here to finesse things.
  const l = splitLocale(locale).region ?? 'US';
  return firstDayMap[l] ?? defaultFirstDay;
};
//# sourceMappingURL=firstDayOfWeek.js.map